import AverageOfColors from './AverageOfColors';

export default AverageOfColors;
